import { Is } from '../constants';

const privilegesConstants = {
    scopes: {
        self: 100,
        department: 200,
        departments: 300,
        all: 400
    },
    moduleScopes: {
        crm: {
            iCharge: 100, // æè´è´£ç
            iCreate: 200, // æåå»ºç
            iWatch: 300, // æåä¸ç
            iView: 400 // æè½æ¥çç
        },
        okr: {
            iCharge: 100, // æè´è´£ç
            iCreate: 200, // æåå»ºç
            iView: 300 // æè½æ¥çç
        },
        bulletin: {
            iCreate: 200, // æåå»ºç
            iView: 400 // æè½æ¥çç
        }
    },
    type: {
        global: 1,
        module: 2
    }
};

const privilegesDefinition = {
    keys: {
        __KEY_DISPLAY_POSITION: '__display_position',
        __KEY_STORAGE_POSITION: '__storage_position',
        __KEY_ADMIN_DEFAULT: '__admin_default',
        __KEY_ADMIN_DEFAULT_SCOPE: '__admin_default_scope',
        __KEY_MEMBER_DEFAULT: '__member_default',
        __KEY_MEMBER_DEFAULT_SCOPE: '__member_default_scope'
    },
    names: {
        admin: 1,
        message: 2,
        mission: 3,
        calendar: 4,
        drive: 5,
        report: 6,
        crm: 7,
        approval: 8,
        leave: 9,
        appraisal: 10,
        bulletin: 11,
        okr: 12,
        portal: 13,
        mission_vnext: 14
    },
    global: {
        message: {
            __display_position: 100,
            create_public_channel: {
                __display_position: 100,
                __storage_position: 0,
                __admin_default: Is.yes,
                key: 'create_public_channel'
            },
            create_private_channel: {
                __display_position: 200,
                __storage_position: 1,
                __admin_default: Is.yes,
                key: 'create_private_channel'
            },
            admin_public_channel: {
                __display_position: 300,
                __storage_position: 2,
                __admin_default: Is.yes,
                key: 'admin_public_channel'
            },
            send_message_in_team_channel: {
                __display_position: 400,
                __storage_position: 3,
                __admin_default: Is.yes,
                __member_default: Is.yes,
                key: 'send_message_in_team_channel'
            },
            remove_message_in_channel: {
                __display_position: 500,
                __storage_position: 4,
                __admin_default: Is.yes,
                key: 'remove_message_in_channel'
            },
            update_module_setting: {
                __display_position: 0,
                __storage_position: 5,
                __admin_default: Is.yes,
                key: 'update_module_setting'
            }
        },
        mission: {
            __display_position: 100,
            create_public_project: {
                __display_position: 100,
                __storage_position: 0,
                __admin_default: Is.yes,
                key: 'create_public_project'
            },
            create_private_project: {
                __display_position: 200,
                __storage_position: 1,
                __admin_default: Is.yes,
                key: 'create_private_project'
            },
            admin_public_project: {
                __display_position: 300,
                __storage_position: 2,
                __admin_default: Is.yes,
                key: 'admin_public_project'
            },
            update_module_setting: {
                __display_position: 0,
                __storage_position: 3,
                __admin_default: Is.yes,
                key: 'update_module_setting'
            },
            admin_tag: {
                __display_position: 400,
                __storage_position: 4,
                __admin_default: Is.yes,
                key: 'admin_tag'
            }
        },
        mission_vnext: {
            __display_position: 150,
            create_public_project: {
                __display_position: 100,
                __storage_position: 0,
                __admin_default: Is.yes,
                key: 'create_public_project'
            },
            create_private_project: {
                __display_position: 200,
                __storage_position: 1,
                __admin_default: Is.yes,
                key: 'create_private_project'
            },
            admin_public_project: {
                __display_position: 300,
                __storage_position: 2,
                __admin_default: Is.yes,
                key: 'admin_public_project'
            },
            update_module_setting: {
                __display_position: 0,
                __storage_position: 3,
                __admin_default: Is.yes,
                key: 'update_module_setting'
            }
        },
        calendar: {
            __display_position: 200,
            create_public_calendar: {
                __display_position: 100,
                __storage_position: 0,
                __admin_default: Is.yes,
                key: 'create_public_calendar'
            },
            create_private_calendar: {
                __display_position: 200,
                __storage_position: 1,
                __admin_default: Is.yes,
                key: 'create_private_calendar'
            },
            admin_public_calendar: {
                __display_position: 300,
                __storage_position: 2,
                __admin_default: Is.yes,
                key: 'admin_public_calendar'
            },
            update_module_setting: {
                __display_position: 0,
                __storage_position: 3,
                __admin_default: Is.yes,
                key: 'update_module_setting'
            }
        },
        drive: {
            __display_position: 300,
            create_drive_on_root: {
                __display_position: 100,
                __storage_position: 0,
                __admin_default: Is.yes,
                key: 'create_drive_on_root'
            },
            admin_public_folder: {
                __display_position: 300,
                __storage_position: 2,
                __admin_default: Is.yes,
                key: 'admin_public_folder'
            },
            admin_tag: {
                __display_position: 400,
                __storage_position: 3,
                __admin_default: Is.yes,
                key: 'admin_tag'
            },
            update_module_setting: {
                __display_position: 0,
                __storage_position: 1,
                __admin_default: Is.yes,
                key: 'update_module_setting'
            }
        },
        report: {
            __display_position: 400,
            __admin_default_scope: {
                view: privilegesConstants.scopes.all
            },
            __member_default_scope: {
                view: privilegesConstants.scopes.self
            },
            view_report_stats: {
                __display_position: 100,
                __storage_position: 0,
                __admin_default: Is.no,
                key: 'view_report_stats'
            },
            export_report_stats: {
                __display_position: 200,
                __storage_position: 1,
                key: 'export_report_stats'
            },
            update_module_setting: {
                __display_position: 0,
                __storage_position: 2,
                key: 'update_module_setting'
            }
        },
        crm: {
            __display_position: 500,
            __admin_default_scope: {
                view: privilegesConstants.scopes.all,
                manage: [
                    privilegesConstants.moduleScopes.crm.iCharge,
                    privilegesConstants.moduleScopes.crm.iCreate,
                    privilegesConstants.moduleScopes.crm.iWatch,
                    privilegesConstants.moduleScopes.crm.iView
                ]
            },
            __member_default_scope: {
                view: privilegesConstants.scopes.self,
                manage: [privilegesConstants.moduleScopes.crm.iCharge]
            },
            create_customer: {
                __display_position: 100,
                __storage_position: 0,
                key: 'create_customer'
            },
            admin_customer: {
                __display_position: 200,
                __storage_position: 1,
                key: 'admin_customer'
            },
            admin_customer_contact: {
                __display_position: 300,
                __storage_position: 2,
                key: 'admin_customer_contact'
            },
            lock_customer: {
                __display_position: 400,
                __storage_position: 3,
                key: 'lock_customer'
            },
            create_contract: {
                __display_position: 500,
                __storage_position: 4,
                key: 'create_contract'
            },
            admin_contract: {
                __display_position: 600,
                __storage_position: 5,
                key: 'admin_contract'
            },
            customer_stats: {
                __display_position: 800,
                __storage_position: 6,
                key: 'customer_stats'
            },
            sales_stats: {
                __display_position: 900,
                __storage_position: 7,
                key: 'sales_stats'
            },
            contract_stats: {
                __display_position: 1000,
                __storage_position: 8,
                key: 'contract_stats'
            },
            update_module_setting: {
                __display_position: 0,
                __storage_position: 9,
                __admin_default: Is.yes,
                key: 'update_module_setting'
            },
            admin_tag: {
                __display_position: 700,
                __storage_position: 10,
                key: 'admin_tag'
            },
            export_customers: {
                __display_position: 1100,
                __storage_position: 11,
                __admin_default: Is.yes,
                key: 'export_customers'
            }
        },
        approval: {
            __display_position: 600,
            __admin_default_scope: {
                view: privilegesConstants.scopes.all
            },
            __member_default_scope: {
                view: privilegesConstants.scopes.self
            },
            export_stats: {
                __display_position: 100,
                __storage_position: 0,
                key: 'export_stats'
            },
            update_module_setting: {
                __display_position: 0,
                __storage_position: 1,
                __admin_default: Is.yes,
                key: 'update_module_setting'
            },
            desert_approval: {
                __display_position: 200,
                __storage_position: 2,
                key: 'desert_approval'
            }
        },
        leave: {
            __display_position: 700,
            __admin_default_scope: {
                view: privilegesConstants.scopes.all
            },
            __member_default_scope: {
                view: privilegesConstants.scopes.self
            },
            view_stats: {
                __display_position: 100,
                __storage_position: 0,
                key: 'view_stats'
            },
            export_stats: {
                __display_position: 200,
                __storage_position: 1,
                key: 'export_stats'
            },
            desert_application: {
                __display_position: 300,
                __storage_position: 2,
                key: 'desert_application'
            },
            update_module_setting: {
                __display_position: 0,
                __storage_position: 3,
                __admin_default: Is.yes,
                key: 'update_module_setting'
            }
        },
        admin: {
            __display_position: 800,
            admin_members: {
                __display_position: 100,
                __storage_position: 0,
                __admin_default: Is.yes,
                key: 'admin_members'
            },
            admin_role: {
                __display_position: 200,
                __storage_position: 1,
                key: 'admin_role'
            },
            admin_applications: {
                __display_position: 300,
                __storage_position: 2,
                __admin_default: Is.yes,
                key: 'admin_applications'
            },
            admin_services: {
                __display_position: 400,
                __storage_position: 3,
                __admin_default: Is.yes,
                key: 'admin_services'
            },
            admin_data: {
                __display_position: 500,
                __storage_position: 4,
                key: 'admin_data'
            },
            admin_security: {
                __display_position: 600,
                __storage_position: 5,
                key: 'admin_security'
            },
            admin_billing: {
                __display_position: 700,
                __storage_position: 6,
                key: 'admin_billing'
            },
            admin_data_stats: {
                __display_position: 800,
                __storage_position: 7,
                __admin_default: Is.yes,
                key: 'admin_data_stats'
            },
            admin_basic_setting: {
                __display_position: 900,
                __storage_position: 8,
                key: 'admin_basic_setting'
            },
            admin_logo_setting: {
                __display_position: 1000,
                __storage_position: 9,
                __admin_default: Is.yes,
                key: 'admin_logo_setting'
            },
            admin_loadings_setting: {
                __display_position: 1100,
                __storage_position: 10,
                __admin_default: Is.yes,
                key: 'admin_loadings_setting'
            }
        },
        appraisal: {
            __display_position: 900,
            evaluation_manage: {
                __display_position: 0,
                __storage_position: 0,
                __admin_default: Is.yes,
                key: 'evaluation_manage'
            },
            indicator_manage: {
                __display_position: 100,
                __storage_position: 1,
                __admin_default: Is.yes,
                key: 'indicator_manage'
            },
            enum_manage: {
                __display_position: 200,
                __storage_position: 2,
                __admin_default: Is.yes,
                key: 'enum_manage'
            },
            template_manage: {
                __display_position: 300,
                __storage_position: 3,
                __admin_default: Is.yes,
                key: 'template_manage'
            },
            view_stats: {
                __display_position: 400,
                __storage_position: 4,
                __admin_default: Is.yes,
                key: 'view_stats'
            }
        },
        bulletin: {
            __display_position: 1300,
            __admin_default_scope: {
                view: privilegesConstants.scopes.self,
                manage: [
                    privilegesConstants.moduleScopes.bulletin.iCreate,
                    privilegesConstants.moduleScopes.bulletin.iView
                ]
            },
            __member_default_scope: {
                view: privilegesConstants.scopes.self,
                manage: [
                    privilegesConstants.moduleScopes.bulletin.iCreate,
                    privilegesConstants.moduleScopes.bulletin.iView
                ]
            },
            admin_create_notice: {
                __display_position: 200,
                __storage_position: 1,
                __admin_default: Is.yes,
                key: 'admin_create_notice'
            },
            admin_notice: {
                __display_position: 100,
                __storage_position: 0,
                __admin_default: Is.yes,
                key: 'admin_notice'
            },
            admin_notice_category: {
                __display_position: 300,
                __storage_position: 2,
                __admin_default: Is.yes,
                key: 'admin_notice_category'
            },
            admin_create_vote: {
                __display_position: 400,
                __storage_position: 3,
                __admin_default: Is.yes,
                key: 'admin_create_vote'
            },
            admin_vote: {
                __display_position: 500,
                __storage_position: 4,
                __admin_default: Is.yes,
                key: 'admin_vote'
            }
        },
        portal: {
            admin_panel_new: {
                __display_position: 100,
                __storage_position: 0,
                __admin_default: Is.yes,
                key: 'admin_panel_new'
            },
            admin_panel_setting: {
                __display_position: 200,
                __storage_position: 1,
                __admin_default: Is.yes,
                key: 'admin_panel_setting'
            }
        },
        okr: {
            __display_position: 1200,
            __admin_default_scope: {
                view: privilegesConstants.scopes.all,
                manage: [
                    privilegesConstants.moduleScopes.okr.iCharge,
                    privilegesConstants.moduleScopes.okr.iCreate,
                    privilegesConstants.moduleScopes.okr.iView
                ]
            },
            __member_default_scope: {
                view: privilegesConstants.scopes.all,
                manage: [privilegesConstants.moduleScopes.okr.iCharge, privilegesConstants.moduleScopes.okr.iCreate]
            },
            update_module_setting: {
                __display_position: 100,
                __storage_position: 0,
                __admin_default: Is.yes,
                key: 'update_module_setting'
            },
            admin_objective: {
                __display_position: 200,
                __storage_position: 1,
                __admin_default: Is.yes,
                __member_default: Is.yes,
                key: 'admin_objective'
            },
            admin_cycle: {
                __display_position: 300,
                __storage_position: 2,
                __admin_default: Is.yes,
                key: 'admin_cycle'
            }
        }
    },
    modules: {
        mission: {
            project_setting: {
                __display_position: 100,
                __storage_position: 0,
                __admin_default: Is.yes,
                key: 'project_setting'
            },
            project_share: {
                __display_position: 200,
                __storage_position: 1,
                __admin_default: Is.yes,
                key: 'project_share'
            },
            project_clone: {
                __display_position: 300,
                __storage_position: 2,
                __admin_default: Is.yes,
                key: 'project_clone'
            },
            project_export: {
                __display_position: 400,
                __storage_position: 3,
                __admin_default: Is.yes,
                key: 'project_export'
            },
            entry_create: {
                __display_position: 500,
                __storage_position: 4,
                __admin_default: Is.yes,
                key: 'entry_create'
            },
            entry_edit: {
                __display_position: 600,
                __storage_position: 5,
                __admin_default: Is.yes,
                key: 'entry_edit'
            },
            entry_move: {
                __display_position: 700,
                __storage_position: 6,
                __admin_default: Is.yes,
                key: 'entry_move'
            },
            entry_clone: {
                __display_position: 800,
                __storage_position: 7,
                __admin_default: Is.yes,
                key: 'entry_clone'
            },
            entry_remove: {
                __display_position: 900,
                __storage_position: 8,
                __admin_default: Is.yes,
                key: 'entry_remove'
            },
            task_create: {
                __display_position: 1000,
                __storage_position: 9,
                __admin_default: Is.yes,
                key: 'task_create'
            },
            task_complete: {
                __display_position: 1100,
                __storage_position: 10,
                __admin_default: Is.yes,
                key: 'task_complete'
            },
            task_edit: {
                __display_position: 1200,
                __storage_position: 11,
                __admin_default: Is.yes,
                key: 'task_edit'
            },
            task_edit_description: {
                __display_position: 1300,
                __storage_position: 12,
                __admin_default: Is.yes,
                key: 'task_edit_description'
            },
            task_assign: {
                __display_position: 1400,
                __storage_position: 13,
                __admin_default: Is.yes,
                key: 'task_assign'
            },
            task_set_begin_due_date: {
                __display_position: 1500,
                __storage_position: 14,
                __admin_default: Is.yes,
                key: 'task_set_begin_due_date'
            },
            task_set_workload_estimated: {
                __display_position: 1600,
                __storage_position: 15,
                __admin_default: Is.yes,
                key: 'task_set_workload_estimated'
            },
            task_set_workload_entry: {
                __display_position: 1700,
                __storage_position: 16,
                __admin_default: Is.yes,
                key: 'task_set_workload_entry'
            },
            task_set_tag: {
                __display_position: 1800,
                __storage_position: 17,
                __admin_default: Is.yes,
                key: 'task_set_tag'
            },
            task_add_watcher: {
                __display_position: 1900,
                __storage_position: 18,
                __admin_default: Is.yes,
                key: 'task_add_watcher'
            },
            task_set_priority: {
                __display_position: 2100,
                __storage_position: 20,
                __admin_default: Is.yes,
                key: 'task_set_priority'
            },
            task_set_reminders: {
                __display_position: 2200,
                __storage_position: 21,
                __admin_default: Is.yes,
                key: 'task_set_reminders'
            },
            task_set_recurrence: {
                __display_position: 2300,
                __storage_position: 22,
                __admin_default: Is.yes,
                key: 'task_set_recurrence'
            },
            task_lock: {
                __display_position: 2400,
                __storage_position: 23,
                __admin_default: Is.yes,
                key: 'task_lock'
            },
            task_switch_private: {
                __display_position: 2500,
                __storage_position: 24,
                __admin_default: Is.yes,
                key: 'task_switch_private'
            },
            task_share: {
                __display_position: 2600,
                __storage_position: 25,
                __admin_default: Is.yes,
                key: 'task_share'
            },
            task_move: {
                __display_position: 2700,
                __storage_position: 26,
                __admin_default: Is.yes,
                key: 'task_move'
            },
            task_clone: {
                __display_position: 2800,
                __storage_position: 27,
                __admin_default: Is.yes,
                key: 'task_clone'
            },
            task_archive: {
                __display_position: 2900,
                __storage_position: 28,
                __admin_default: Is.yes,
                key: 'task_archive'
            },
            task_delete: {
                __display_position: 3000,
                __storage_position: 29,
                __admin_default: Is.yes,
                key: 'task_delete'
            },
            child_task_create: {
                __display_position: 3100,
                __storage_position: 30,
                __admin_default: Is.yes,
                key: 'child_task_create'
            },
            task_shred: {
                __display_position: 3200,
                __storage_position: 31,
                __admin_default: Is.yes,
                key: 'task_shred'
            },
            task_set_extension_field_value: {
                __display_position: 3300,
                __storage_position: 32,
                __admin_default: Is.yes,
                key: 'task_set_extension_field_value'
            },
            task_add_attachment: {
                __display_position: 3400,
                __storage_position: 33,
                __admin_default: Is.yes,
                key: 'task_add_attachment'
            },
            task_remove_attachment: {
                __display_position: 3500,
                __storage_position: 34,
                __admin_default: Is.yes,
                key: 'task_remove_attachment'
            }
        },
        calendar: {
            calendar_setting: {
                __display_position: 100,
                __storage_position: 0,
                __admin_default: Is.yes,
                key: 'calendar_setting'
            },
            calendar_share: {
                __display_position: 200,
                __storage_position: 1,
                __admin_default: Is.yes,
                key: 'calendar_share'
            },
            event_create: {
                __display_position: 300,
                __storage_position: 2,
                __admin_default: Is.yes,
                key: 'event_create'
            },
            event_share: {
                __display_position: 400,
                __storage_position: 3,
                __admin_default: Is.yes,
                key: 'event_share'
            },
            event_edit: {
                __display_position: 500,
                __storage_position: 4,
                __admin_default: Is.yes,
                key: 'event_edit'
            },
            event_remove: {
                __display_position: 600,
                __storage_position: 5,
                __admin_default: Is.yes,
                key: 'event_remove'
            },
            event_reminder_setting: {
                __display_position: 700,
                __storage_position: 6,
                __admin_default: Is.yes,
                key: 'event_reminder_setting'
            },
            event_add_attachment: {
                __display_position: 800,
                __storage_position: 7,
                __admin_default: Is.yes,
                key: 'event_add_attachment'
            },
            event_remove_attachment: {
                __display_position: 900,
                __storage_position: 8,
                __admin_default: Is.yes,
                key: 'event_remove_attachment'
            }
        },
        drive: {
            folder_setting: {
                __display_position: 100,
                __storage_position: 0,
                __admin_default: Is.yes,
                key: 'folder_setting'
            },
            folder_create: {
                __display_position: 200,
                __storage_position: 1,
                __admin_default: Is.yes,
                key: 'folder_create'
            },
            folder_share: {
                __display_position: 300,
                __storage_position: 2,
                __admin_default: Is.yes,
                key: 'folder_share'
            },
            file_share: {
                __display_position: 400,
                __storage_position: 3,
                __admin_default: Is.yes,
                key: 'file_share'
            },
            file_edit: {
                __display_position: 500,
                __storage_position: 4,
                __admin_default: Is.yes,
                key: 'file_edit'
            },
            drive_remove: {
                __display_position: 600,
                __storage_position: 5,
                __admin_default: Is.yes,
                key: 'drive_remove'
            },
            file_upload: {
                __display_position: 800,
                __storage_position: 6,
                __admin_default: Is.yes,
                key: 'file_upload'
            },
            file_download: {
                __display_position: 900,
                __storage_position: 7,
                __admin_default: Is.yes,
                key: 'file_download'
            },
            file_preview: {
                __display_position: 1000,
                __storage_position: 8,
                __admin_default: Is.yes,
                key: 'file_preview'
            },
            file_set_tag: {
                __display_position: 1100,
                __storage_position: 9,
                __admin_default: Is.yes,
                key: 'file_set_tag'
            },
            drive_move: {
                __display_position: 700,
                __storage_position: 10,
                __admin_default: Is.yes,
                key: 'drive_move'
            },
            drive_copy: {
                __display_position: 700,
                __storage_position: 11,
                __admin_default: Is.yes,
                key: 'drive_copy'
            }
        }
    }
};
const _getPrivilegesStorageArrayFromDefinition = function(moduleDefinition) {
    const modulePrivileges = [];
    // convert definition from object to array
    for (const name in moduleDefinition) {
        if (
            moduleDefinition.hasOwnProperty(name) &&
            name !== privilegesDefinition.keys.__KEY_DISPLAY_POSITION &&
            name !== privilegesDefinition.keys.__KEY_ADMIN_DEFAULT_SCOPE &&
            name !== privilegesDefinition.keys.__KEY_MEMBER_DEFAULT_SCOPE
        ) {
            modulePrivileges.push(moduleDefinition[name]);
        }
    }
    // sort array based on its `__storage_position` property
    modulePrivileges.sort(function(x, y) {
        if (
            x[privilegesDefinition.keys.__KEY_STORAGE_POSITION] === y[privilegesDefinition.keys.__KEY_STORAGE_POSITION]
        ) {
            throw new Error('Duplicated storage position value between privileges ' + x.key + ' and ' + y.key);
        }
        return (
            x[privilegesDefinition.keys.__KEY_STORAGE_POSITION] - y[privilegesDefinition.keys.__KEY_STORAGE_POSITION]
        );
    });
    return modulePrivileges.map(function(privilege) {
        return privilege.key;
    });
};

const privileges = {
    definition: privilegesDefinition,
    global: {
        message: _getPrivilegesStorageArrayFromDefinition(privilegesDefinition.global.message),
        mission: _getPrivilegesStorageArrayFromDefinition(privilegesDefinition.global.mission),
        calendar: _getPrivilegesStorageArrayFromDefinition(privilegesDefinition.global.calendar),
        drive: _getPrivilegesStorageArrayFromDefinition(privilegesDefinition.global.drive),
        report: _getPrivilegesStorageArrayFromDefinition(privilegesDefinition.global.report),
        crm: _getPrivilegesStorageArrayFromDefinition(privilegesDefinition.global.crm),
        approval: _getPrivilegesStorageArrayFromDefinition(privilegesDefinition.global.approval),
        leave: _getPrivilegesStorageArrayFromDefinition(privilegesDefinition.global.leave),
        admin: _getPrivilegesStorageArrayFromDefinition(privilegesDefinition.global.admin),
        appraisal: _getPrivilegesStorageArrayFromDefinition(privilegesDefinition.global.appraisal),
        bulletin: _getPrivilegesStorageArrayFromDefinition(privilegesDefinition.global.bulletin),
        portal: _getPrivilegesStorageArrayFromDefinition(privilegesDefinition.global.portal),
        okr: _getPrivilegesStorageArrayFromDefinition(privilegesDefinition.global.okr)
    },
    modules: {
        mission: _getPrivilegesStorageArrayFromDefinition(privilegesDefinition.modules.mission),
        calendar: _getPrivilegesStorageArrayFromDefinition(privilegesDefinition.modules.calendar),
        drive: _getPrivilegesStorageArrayFromDefinition(privilegesDefinition.modules.drive)
    },
    moduleScopes: privilegesConstants.moduleScopes,
    scopes: privilegesConstants.scopes,
    type: privilegesConstants.type
};

export const permissionConstant = {
    privilegesConstants: privilegesConstants,
    privilegesDefinition: privilegesDefinition,
    privileges: privileges,
    HAS_PERMISSION_MASK: '1',
    NO_PERMISSION_MASK: '0'
};
